import { use_slice_ui } from '@/hooks/store/use_slices';
import { FIELD__base } from '@shared/dto/generation/graph_invoke/_fields/_base/FIELD__base';
import { Handle, Position } from '@xyflow/react';
import { G_GRAPH__handle_edges_amount } from './G_GRAPH__handle_edges_amount';
import { G_GRAPH__handle_icon_wanted_to_be_filled } from './G_GRAPH__handle_icon_wanted_to_be_filled';
import { HOOK__handle_is_connectable_base } from './HOOK__handle_is_connectable_base';

interface PROPS {
  field: FIELD__base;
}

export function G_GRAPH__handle_left({ field }: PROPS) {
  /*
   * STORE
   */

  const { g_graph__new_edge_field_position, g_graph__new_edge_field, g_general__ui_disabled } = use_slice_ui([
    'g_graph__new_edge_field_position',
    'g_graph__new_edge_field',
    'g_general__ui_disabled',
  ]);

  let is_connectable_base = HOOK__handle_is_connectable_base(field);

  /*
   * STATE
   */
  let is_connectable = get_is_connectable();

  /*
   * METHODS
   */

  function get_is_connectable() {
    if (g_graph__new_edge_field_position == Position.Left) return false;

    return is_connectable_base;
  }

  function get_class_name() {
    if (g_graph__new_edge_field.meta.field_id == field.meta.field_id && g_graph__new_edge_field_position == Position.Left) return '!opacity-100'; //this handle selected

    return is_connectable ? '!opacity-100' : '!opacity-0';
  }

  /*
   * HTML
   */

  //we allow only for grid2d out read only fields
  if (field.meta.kind__is_input && field.meta.ui__is_readonly) return null;

  return (
    <>
      <G_GRAPH__handle_icon_wanted_to_be_filled {...{ field }} />

      <Handle
        type="target"
        position={Position.Left}
        id={`${field.meta.field_id}_${Position.Left}`}
        isConnectable={is_connectable}
        className={`
        !left-[-0.5rem] 
        !w-3 
        !h-4 
        !bg-white
        ${get_class_name()}
        hover:!opacity-100 
        !border-none
        !rounded-r-none 
        !rounded-l-[4px]
        ${g_general__ui_disabled && '!pointer-events-none'}
        `}
      >
        <G_GRAPH__handle_edges_amount {...{ field }} edges_to={true} />
      </Handle>
    </>
  );
}
